import { render, staticRenderFns } from "./CollectionsView.vue?vue&type=template&id=a4652e48&"
import script from "./CollectionsView.vue?vue&type=script&lang=ts&"
export * from "./CollectionsView.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsView.vue?vue&type=style&index=0&id=a4652e48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports